import { render } from "./QuickpayPaymentLayout.vue?vue&type=template&id=c317e5b6&scoped=true"
const script = {}

import "./QuickpayPaymentLayout.vue?vue&type=style&index=0&id=c317e5b6&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c317e5b6"]])

export default __exports__